import Footer from "../../components/Footer";
import Header from "../../components/Header";

import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";
import TurnkeyProjects from "../../components/Service/Subservice/turnkeyprojects";

export default function TurnkeyProjectsPage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"Turnkey EVCS, CBG & CNG Deployment"}/>
            <TurnkeyProjects/>
            <Footer/>
        </>
    )
}